import Query from '../../components/Report';

const query = ({ offset = 0, domain = '', limit = 100 }) =>
    new Query('discover-authors', {
        offset,
        extra_domain: domain,
        limit,
    });

export default query;
